import apiClient from '../utils/apiClient';

const get = async (path, params) => (await apiClient.get(`/api/dashboard/${path}`, { params })).data;

export const dashboardService = {
  getExecutiveSnapshot: () => get('snapshot'),
  // Mon–Fri hours per person for the week starting weekStart ('YYYY-MM-DD').
  getCapacity: (weekStart) => get('capacity', { week_start: weekStart }),
  getAttentionRequired: () => get('attention'),
  getProjectStatusOverview: () => get('projects/overview'),
  getUpcomingDeadlines: () => get('deadlines'),
  // Every report for one period: { period, client_id, employee_id, people }.
  getReports: (params) => get('reports', params),
  getPersonalDashboard: (weekStart) => get('personal', { week_start: weekStart }),
};
